module.exports = __webpack_public_path__ + "media/images/about_us/schema-c539629d21f0e866278f2fa826d45499.svg";